import { TimeRestrictionsStore } from '../types/store';

export const shouldCheckNavigation = (
  timeRestrictions: TimeRestrictionsStore
) => timeRestrictions.is_lock_navigation || timeRestrictions.is_lock_computer;
